/**
 * Application-wide configuration constants
 */

export const DEFAULT_COURSE_CODE = 'DEMO' as const;

// Add other application-wide constants below
export const APP_CONFIG = {
  // Default pagination settings
  pagination: {
    defaultPageSize: 10,
  },
  // API configuration
  api: {
    timeout: 30000, // 30 seconds
    maxRetries: 3,
  },
} as const;
